import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "cn";
import type { ComponentProps } from "react";

const iconTileVariants = cva("grid place-items-center rounded-lg border", {
  variants: {
    size: {
      default: "size-10",
      sm: "size-8",
    },
    variant: {
      neutral: "border-border bg-muted text-foreground",
      destructive: "border-destructive/35 bg-destructive/14 text-destructive",
      secondary: "border-transparent bg-secondary text-foreground",
    },
  },
  defaultVariants: {
    size: "default",
    variant: "neutral",
  },
});

/**
 * Плитка-иконка (40 px, `sm` — 32 px) над заголовком экрана или в шапке панели.
 * Декоративна (`aria-hidden`): смысл несёт текст рядом; значок передаётся детьми.
 */
function IconTile({
  className,
  variant = "neutral",
  size = "default",
  ...props
}: ComponentProps<"span"> & VariantProps<typeof iconTileVariants>) {
  return (
    <span
      data-slot="icon-tile"
      aria-hidden="true"
      className={cn(iconTileVariants({ variant, size }), className)}
      {...props}
    />
  );
}

export { IconTile, iconTileVariants };
